import React from 'react'
import { observer } from 'mobx-react'
import FirmDashboardJobsViewModel from '../../FirmDashboardJobsViewer/FirmDashboardJobTableViewModel'
import Button from 'components/Button'
import Icon from 'components/Icon'
import Tooltip from 'components/Tooltip'
import UnreadBadge from 'components/UnreadBadge'
import TableControls from '../FirmDashboardTableControls'
import styles from './FirmDashboardPrimaryControls.sass'

interface FirmDashboardPrimaryControlsProps {
  vm: FirmDashboardJobsViewModel
  filterCount: number
  value: string
  onChange: (val: string) => void
  onShowFilterControlsClick: () => void
}

export default observer(function FirmDashboardPrimaryControls({
  vm,
  filterCount,
  value,
  onChange,
  onShowFilterControlsClick,
}: FirmDashboardPrimaryControlsProps) {
  const hasFilter = filterCount > 0
  const filterTooltip = hasFilter
    ? `${filterCount} ${filterCount > 1 ? 'filters' : 'filter'} selected`
    : 'Filter'
  const menuTooltip = 'Menu'

  return (
    <div className={styles.primaryControls}>
      <div className={styles.search}>
        <Icon name="search" />
        <input
          type="text"
          value={value}
          placeholder="Search"
          className={styles.searchInput}
          data-test="job-search-field"
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      <div className={styles.actions}>
        <div className={styles.actionButton}>
          <Tooltip content={filterTooltip} placement="bottom">
            <Button
              onClick={onShowFilterControlsClick}
              size="baseline"
              type="text"
              dataTest={'job-filter-controls-toggle'}
            >
              <Icon color="var(--grey600)" name="filter" />
              {filterCount > 0 && (
                <UnreadBadge
                  className={styles.filterCount}
                  count={filterCount}
                />
              )}
            </Button>
          </Tooltip>
        </div>
        <div className={styles.actionButton}>
          <TableControls
            vm={vm}
            button={
              <Tooltip content={menuTooltip} placement="bottom">
                <Button
                  size="baseline"
                  type="text"
                  dataTest={'job-management-table-menu-toggle'}
                >
                  <Icon color="var(--grey600)" name="more" />
                </Button>
              </Tooltip>
            }
          />
        </div>
      </div>
    </div>
  )
})
